<template>
  <div class="search-live-standard container">
    <el-form ref="form" :model="form" :rules="rules" size="small">
      <create-choice
        :contentArr="['直播带货', '搜索广告', '专业推广']"
        @onChange="show = true"
      />

      <choose-account title="请选择要开播的抖音号" type="live" />

      <search-terms :form="form" :haveProduct="true" :list="wordList" />

      <div>
        <p class="level-2">
          智选流量
          <el-popover placement="top" trigger="hover" width="330">
            <p style="font-size: 12px; line-height: 1.8">
              开启后系统将在关键词的基础上，智能识别并扩展相似流量，帮助计划跑量。如：
            </p>
            <p style="font-size: 12px; line-height: 1.8">
              计划投放已[台灯为主]，智选流量将为您新增“床头灯、小夜灯”等流量，帮助拓量
            </p>
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </p>
        <el-radio-group v-model="form.flow" size="medium">
          <el-radio-button label="开启"></el-radio-button>
          <el-radio-button label="关闭"></el-radio-button>
        </el-radio-group>
      </div>

      <delivery-setting :form="form" />

      <div class="creative-module">
        <p class="level-1">请为直播间添加创意</p>
        <p class="level-2">创意形式</p>
        <el-radio-group v-model="form.creativeForm" size="medium">
          <el-radio-button label="直播间画面"></el-radio-button>
          <el-radio-button label="视频"></el-radio-button>
        </el-radio-group>
        <p class="tips" v-show="form.creativeForm == '直播间画面'">
          <i class="el-icon-info"></i
          >直播期间，系统将推广直播间画面，并展示相关推广卡片。
        </p>

        <div v-show="form.creativeForm == '视频'">
          <add-video
            :videoNum="videoNum"
            :videoMax="10"
            title="添加创意内容"
            rightBtn="直播剪辑工具"
            @onConfirm="onConfirm"
          />

          <div class="switch-bottom">
            <p class="level-2">
              抖音主页隐藏视频
              <el-popover placement="top" trigger="hover">
                <p style="font-size: 12px">
                  隐藏后，用户在你的选择的抖音号的主页看不到新增的视频创意
                </p>
                <p style="margin-top: 5px; color: #909399; font-size: 12px">
                  注意：计划自动生成的视频创意将默认隐藏，不跟随设置变化
                </p>
                <i class="el-icon-question" slot="reference"></i>
              </el-popover>
            </p>
            <el-radio-group v-model="form.hide" size="medium">
              <el-radio-button label="隐藏"></el-radio-button>
              <el-radio-button label="不隐藏"></el-radio-button>
            </el-radio-group>
          </div>
        </div>

        <div class="creative-preview">
          <div class="title-section">
            <p class="title-text">
              {{
                form.creativeForm == "直播间画面"
                  ? "直播间画面预览"
                  : "创意预览"
              }}
            </p>
            <div class="change-arrow" v-show="form.creativeForm == '视频'">
              <i class="el-icon-back icon mr"></i>
              <i class="el-icon-right icon"></i>
            </div>
          </div>
          <div class="component-preview-wrapper">
            <div class="live" v-if="form.creativeForm == '直播间画面'"></div>
            <div class="video" v-else>
              <el-image
                v-if="videoNum > 0"
                class="cover"
                :src="require('@/assets/images/simulation/s_live_cover.png')"
                fit="cover"
              ></el-image>
              <div class="not-support" v-else>
                <el-image
                  style="width: 100px; height: 72px"
                  :src="require('@/assets/images/simulation/empty.png')"
                  fit="cover"
                ></el-image>
                <p class="empty-text">请先选择一个创意视频</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <creative-label :form="form" />

      <form-bottom
        :form="form"
        :show="show"
        @onSubmit="handleRelease"
        @onClose="show = false"
        @onCancel="show = true"
      />
    </el-form>
  </div>
</template>

<script>
import ChooseAccount from "../components/chooseAccount.vue";
import createChoice from "../components/createChoice.vue";
import SearchTerms from "../components/searchTerms.vue";
import DeliverySetting from "./deliverySetting.vue";
import AddVideo from "../components/addVideo.vue";
import CreativeLabel from "../components/creativeLabel.vue";
import FormBottom from "../components/formBottom.vue";
import { submit } from "@/api/chapterMock";

export default {
  components: {
    createChoice,
    ChooseAccount,
    SearchTerms,
    DeliverySetting,
    AddVideo,
    CreativeLabel,
    FormBottom,
  },
  data() {
    var checkBudget = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error("预算不少于300元，不超过9999999.99元，请正确输入")
        );
      }
      if (isNaN(value)) {
        callback(new Error("仅支持输入数字"));
      } else {
        if (value < 300 || value > 9999999.99) {
          callback(
            new Error("预算不少于300元，不超过9999999.99元，请正确输入")
          );
        } else {
          callback();
        }
      }
    };
    var checkBid = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("出价不少于0.1元，不超过10000元"));
      }
      if (isNaN(value)) {
        callback(new Error("仅支持输入数字"));
      } else {
        if (value < 0.1 || value > 10000) {
          callback(new Error("出价不少于0.1元，不超过10000元"));
        } else {
          callback();
        }
      }
    };
    return {
      show: false,
      form: {
        keywords: [
          { id: 1, word: "永辉超市", matchingMode: "广泛" },
          { id: 2, word: "菜市场", matchingMode: "广泛" },
          { id: 3, word: "山姆超市", matchingMode: "广泛" },
          { id: 4, word: "小超市", matchingMode: "广泛" },
        ],
        flow: "开启",
        mode: "控成本投放",
        limit: false,
        deliverySpeed: "尽快投放",
        action: "进入直播间",
        optimizeOrder: false,
        budget: null,
        budgetType: "日预算",
        bid: null,
        dateType: "从今天起长期投放",
        startTime: "",
        endTime: "",
        during: 2,
        timeIntervalType: "不限",
        directional: "自定义人群",
        audience: {
          region: "不限",
          regionArr: [],
          audienceType: "正在该地区的用户",
          sex: "不限",
          age: [],
          network: [],
          platform: "不限",
          autoExtend: "关闭",
        },
        creativeForm: "直播间画面",
        hide: "隐藏",
        creativeClass: "",
        adName: "直播_PC_搜索",
        adGroup: "搜索-直播带货-系统默认分组",
      },
      rules: {
        budget: {
          validator: checkBudget,
          trigger: "blur",
        },
        bid: {
          validator: checkBid,
          trigger: "blur",
        },
      },
      wordList: [
        { id: 1, word: "永辉超市", matchingMode: "广泛" },
        { id: 2, word: "菜市场", matchingMode: "广泛" },
        { id: 3, word: "山姆超市", matchingMode: "广泛" },
        { id: 4, word: "小超市", matchingMode: "广泛" },
        { id: 5, word: "菜场", matchingMode: "广泛" },
        { id: 6, word: "胖东来超市", matchingMode: "广泛" },
        { id: 7, word: "迷你小超市", matchingMode: "广泛" },
        { id: 8, word: "大润发超市", matchingMode: "广泛" },
        { id: 9, word: "生鲜超市", matchingMode: "广泛" },
        { id: 10, word: "一超市", matchingMode: "广泛" },
        { id: 11, word: "仓储超市", matchingMode: "广泛" },
        { id: 12, word: "生活超市", matchingMode: "广泛" },
      ],
      videoNum: 0,
    };
  },
  methods: {
    onConfirm(val) {
      this.videoNum = val;
    },
    // 发布计划
    handleRelease() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm(`确定要提交吗？`)
            .then(() => {
              const classChapterId = localStorage.getItem("mockChapterId");
              submit({
                classChapterId,
                content: JSON.stringify({
                  ...this.form,
                  ...JSON.parse(this.$route.query.form),
                }),
              }).then((res) => {
                this.$alert("提交成功", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    window.close();
                  },
                });
              });
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search-live-standard {
  padding-top: 32px;
  padding-left: 50px;
  text-align: left;
  .level-1 {
    line-height: 34px;
    font-weight: 500;
    font-size: 24px;
    color: #111;
  }
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
  .el-icon-question {
    margin-left: 3px;
    color: #d3d3d3;
    font-size: 16px;
    vertical-align: -1px;
    cursor: pointer;
  }
  .creative-module {
    position: relative;
    .tips {
      margin-top: 20px;
      line-height: 20px;
      font-size: 12px;
      color: #333;
      .el-icon-info {
        margin-right: 5px;
        color: #d3d3d3;
        font-size: 16px;
        vertical-align: -1px;
      }
    }
    .creative-preview {
      position: absolute;
      top: 0px;
      right: 0px;
      width: 310px;
      height: 561px;
      padding: 24px;
      background-color: #fff;
      border: 1px solid #e3e3e4;
      border-radius: 2px;
      .title-section {
        margin-bottom: 21px;
        overflow: hidden;
        .title-text {
          font-weight: 600;
          font-size: 16px;
          line-height: 22px;
          color: #1f1f1f;
          display: inline-block;
        }
        .change-arrow {
          float: right;
          .icon {
            font-size: 20px;
            font-weight: bold;
            color: #999;
            cursor: not-allowed;
            &.mr {
              margin-right: 27px;
            }
          }
        }
      }
      .component-preview-wrapper {
        position: relative;
        width: 264px;
        height: 468px;
        border-radius: 10px;
        border: 1px solid #ebebeb;
        overflow: hidden;
        .live {
          width: 100%;
          height: 100%;
          background-image: url("../../../../assets/images/simulation/s_live_bg.png");
          background-size: 100% 100%;
        }
        .video {
          .not-support {
            padding-top: 160px;
            text-align: center;
            .empty-text {
              margin-top: 8px;
              font-size: 12px;
              line-height: 17px;
              color: #999;
            }
          }
        }
      }
    }
  }
  ::v-deep  .el-radio-group {
    .el-radio-button__inner {
      padding-left: 15px;
      padding-right: 15px;
      min-width: 100px;
      height: 34px;
      background: #f2f2f2;
      border: 1px solid transparent;
      color: #333;
      // border-radius: 4px;
      &:hover {
        background-color: #eff0fe;
      }
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #194ce5;
      border: 1px solid #194ce5;
      background-color: #fff;
      box-shadow: none;
    }
  }
}
</style>